// PDC Spas — products carried by Leisure Wellness Naples as an authorized dealer.
// Data + imagery verified directly against pdcspas.com (model pages, specs, official media CDN).
// All units are "Call for Pricing" — no MSRP shown.

const IMG = (p) => `https://media.cmsmax.cloud/qq67leqlk45sgt0rapx2j/${p}`;

// ---- Categories ----
export const PDC_SPAS_CATEGORIES = [
  {
    id: 'hot-tubs',
    name: 'Hot Tubs',
    description: 'American-made luxury hot tubs across three collections — from the fully loaded Luxury Series with up to 143 hydrotherapy jets, to the feature-rich Premium Series, to the value-driven LifeStyle Series. Every unit is built to order in the USA.',
  },
  {
    id: 'swim-spas',
    name: 'Swim Spas',
    description: 'Voted Swim Spa of the Year. Choose patented TruSwim® dual-propulsion, powerful Summit™ & Synergy™ jetted currents, or the family-friendly Splash Series pool alternative. Fitness, recovery, relaxation and fun in one.',
  },
  {
    id: 'cold-plunges',
    name: 'Cold Plunges',
    description: 'The X-Degree Series brings precision cold-water therapy home. Set temperatures as low as 40°F for recovery or up to 104°F for relaxation. Fits through standard doorways for indoor or outdoor use — proudly made in the USA.',
  },
];

// ---- Shell (acrylic) colors ----
export const PDC_SHELL_COLORS = {
  silverMarble: { name: 'Silver Marble', image: IMG('silver-marble.jpg'), hex: '#C7CBD0' },
  stormCloud: { name: 'Storm Cloud', image: IMG('storm-cloud.jpg'), hex: '#6C7175' },
  midnightCanyon: { name: 'Midnight Canyon', image: IMG('midnight-canyon.jpg'), hex: '#2C2F36' },
  tuscanSun: { name: 'Tuscan Sun', image: IMG('tuscan-sun.jpg'), hex: '#C9A063' },
  smokeyMountain: { name: 'Smokey Mountain', image: IMG('smokey-mountain-shell.jpg'), hex: '#8B9095' },
};

// ---- Cabinet finishes ----
export const PDC_CABINET_COLORS = {
  midnightGraphite: { name: 'Midnight Graphite', image: IMG('site-panel-images-dark-grey.png'), hex: '#383B40' },
  silverwoodGrey: { name: 'Silverwood Grey', image: IMG('site-panel-image-light-grey.jpg'), hex: '#9BA1A7' },
  driftwoodBrown: { name: 'Driftwood Brown', image: IMG('site-panel-image-brown.png'), hex: '#6A4E39' },
  willowBrown: { name: 'Willow Brown', image: IMG('luxury-cabinet-brown-2018.jpg'), hex: '#7C5A3A' },
  smokeGray: { name: 'Smoke Gray', image: IMG('luxury-cabinet-gray-2018.jpg'), hex: '#6B6D6F' },
  black: { name: 'All-Weather Black', image: null, hex: '#141414' },
};

const HT_SHELLS = ['silverMarble', 'stormCloud', 'midnightCanyon', 'tuscanSun', 'smokeyMountain'];
const HT_CABINETS = ['midnightGraphite', 'silverwoodGrey', 'driftwoodBrown'];
const SWIM_CABINETS = ['smokeGray', 'willowBrown'];

// Shared feature sets by series
const F_LUXURY = ['(3) Cascading Waterspouts', 'SmartView Digital Control', "Air'assage™ Air Therapy", 'EverPure™ Ozone w/ EverLite™', 'Halo LED Lighting™', 'PowerFlo™ Filtration', 'Reflections Jetting™ (stainless)', 'TemperLok™ & TemperBase™ Insulation', 'Full acrylic shell color selection', 'PDC Spas Pre-lit Logo'];
const F_PREMIUM = ['(2) Cascading Waterspouts', 'ProView Digital Control', 'EverPure™ Ozone w/ EverLite™', 'Prism™ LED Lighting', 'PowerFlo™ Filtration', 'Reflections Jetting™ (stainless)', 'TemperLok™ & TemperBase™ Insulation', 'Deluxe Thermal Cover', 'PDC Spas Pre-lit Logo'];
const F_LIFESTYLE = ['Reflections™ Stainless Jets', 'Prism™ LED Lighting', 'Pristine™ Filtration', 'TemperLok™ Insulation', 'Digital Topside Control', 'Deluxe Thermal Cover', 'PDC Spas Pre-lit Logo'];
const F_TRUSWIM = ['Patented TruSwim® Dual-Prop Propulsion', 'Reflections Jets™ (stainless)', 'PowerFlo™ Filtration', 'TemperBase™ Insulation', 'Highlights™ LED Lighting', 'EverPure2™ Ozone w/ EverLite™', 'TSX-SmartTouch™ Control Center', 'AquaBar™ Stainless Grip Bar', 'Locking Safety Thermal Cover'];
const F_SUMMIT = ['(3) Adjustable Elite Pro™ Swim Jets', 'Hydrotherapy Reflections Jets™', 'PowerFlo™ Filtration', 'TemperBase™ Insulation', 'LED Lighting', 'EverPure™ Ozone', 'ProView Control', 'Locking Safety Thermal Cover'];
const F_SYNERGY = ['(2) High-Powered Elite Pro™ Jets', 'Hydrotherapy Jets', 'PowerFlo™ Filtration', 'TemperBase™ Insulation', 'LED Lighting', 'EverPure™ Ozone', 'ProView Control', 'Thermal Cover'];
const F_SPLASH = ['Adjustable Elite Pro™ Fitness Jet', 'Therapy Bench, Bucket & Captain\'s Seats', 'ProView™ Control', 'LED Lighting', 'PowerFlo™ Filtration', 'TemperBase™ Insulation', 'Locking Safety Thermal Cover'];
const F_COLD = ['Temperature range 40°F – 104°F', 'Energy-efficient 24-hr circulation pump', 'Multi-color LED lighting', 'EverPure™ ozone water purification', 'Fits through standard doorways', 'Indoor or outdoor use', 'Proudly made in the USA'];

// Lifestyle imagery per category (real in-use PDC photos)
const HT_LIFE = IMG('luxury-series-models.jpg');
const HT_LIFE2 = IMG('premier-series-models.jpg');
const SWIM_LIFE = IMG('truswim-series-bottom-pic.jpg');
const SWIM_LIFE2 = IMG('swim-in-ground-zoomed.png');
const COLD_LIFE = IMG('P1041376.jpg');
const COLD_LIFE2 = IMG('x%20banner_1.png');

export const PDC_SPAS_PRODUCTS = [
  // ===================== HOT TUBS — LUXURY SERIES (35yr) =====================
  {
    id: 'pdc-bali', name: 'Bali', category: 'hot-tubs', series: 'Luxury Series',
    seats: '7 Person', jets: 143, dimensions: '94" x 94" x 39"', gallons: '650', warranty: '35-Year Structural',
    description: 'The flagship Luxury 7-seater. 143 strategically placed jets and a Captain\'s Chair with 70 hydro + 73 air jets deliver total-body hydrotherapy bliss.',
    features: F_LUXURY,
    images: [IMG('2017-bali-shell.jpg'), HT_LIFE],
    shellColors: HT_SHELLS, cabinetColors: HT_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-biscayne', name: 'Biscayne', category: 'hot-tubs', series: 'Luxury Series',
    seats: '5 Person', jets: 96, dimensions: null, gallons: null, warranty: '35-Year Structural',
    description: 'A body-cradling 5-seat luxury design with 96 hydrotherapy jets, Air\'assage™ therapy and Halo LED Lighting™.',
    features: F_LUXURY,
    images: [IMG('2017-biscayne.jpg'), HT_LIFE],
    shellColors: HT_SHELLS, cabinetColors: HT_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-fiji', name: 'Fiji', category: 'hot-tubs', series: 'Luxury Series',
    seats: '6 Person', jets: 115, dimensions: null, gallons: null, warranty: '35-Year Structural',
    description: 'Seats 6 in enriched comfort with 115 jets, a trio of cascading waterspouts and full Luxury Series features.',
    features: F_LUXURY,
    images: [IMG('2017-fiji.jpg'), HT_LIFE],
    shellColors: HT_SHELLS, cabinetColors: HT_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-malibu', name: 'Malibu', category: 'hot-tubs', series: 'Luxury Series',
    seats: '5 Person', jets: 97, dimensions: null, gallons: null, warranty: '35-Year Structural',
    description: 'A refined 5-seat luxury spa with 97 jets and premium hydrotherapy, backed by the 35-year structural warranty.',
    features: F_LUXURY,
    images: [IMG('2017-malibu.jpg'), HT_LIFE],
    shellColors: HT_SHELLS, cabinetColors: HT_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-reno', name: 'Reno', category: 'hot-tubs', series: 'Luxury Series',
    seats: '6 Person', jets: 117, dimensions: null, gallons: null, warranty: '35-Year Structural',
    description: 'Six-seat luxury with 117 jets, Air\'assage™ air therapy, EverPure™ ozone and Halo LED Lighting™.',
    features: F_LUXURY,
    images: [IMG('2017-reno-shell.jpg'), HT_LIFE],
    shellColors: HT_SHELLS, cabinetColors: HT_CABINETS, standardShell: 'silverMarble',
  },

  // ===================== HOT TUBS — PREMIUM SERIES (25yr) =====================
  {
    id: 'pdc-barbados', name: 'Barbados', category: 'hot-tubs', series: 'Premium Series',
    seats: '7 Person', jets: 62, dimensions: null, gallons: null, warranty: '25-Year Structural',
    description: 'A spacious 7-seat Premium spa with 62 jets, maximum water action and high style at a smart value.',
    features: F_PREMIUM,
    images: [IMG('2017-barbados-shell.jpg'), HT_LIFE2],
    shellColors: HT_SHELLS, cabinetColors: HT_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-carmel', name: 'Carmel', category: 'hot-tubs', series: 'Premium Series',
    seats: '3 Person', jets: 28, dimensions: '84" x 60" x 33"', gallons: '220', warranty: '25-Year Structural',
    description: 'Compact yet powerful — a space-saving 84" x 60" design with a reversible recliner, two bucket seats and 28 adjustable jets.',
    features: F_PREMIUM,
    images: [IMG('2019-carmel-shell-900x1209.jpg'), HT_LIFE2],
    shellColors: HT_SHELLS, cabinetColors: HT_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-catalina', name: 'Catalina', category: 'hot-tubs', series: 'Premium Series',
    seats: '5 Person', jets: 54, dimensions: null, gallons: null, warranty: '25-Year Structural',
    description: 'Comfortable 5-seat Premium spa with 54 jets, PowerFlo™ filtration and Prism™ LED lighting.',
    features: F_PREMIUM,
    images: [IMG('2017-catalina-shell.jpg'), HT_LIFE2],
    shellColors: HT_SHELLS, cabinetColors: HT_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-denali', name: 'Denali', category: 'hot-tubs', series: 'Premium Series',
    seats: '7 Person', jets: 61, dimensions: null, gallons: null, warranty: '25-Year Structural',
    description: 'Seats 7 with 61 jets for full-family hydrotherapy, dependable operation and Premium Series comfort.',
    features: F_PREMIUM,
    images: [IMG('2017-denali-shell.jpg'), HT_LIFE2],
    shellColors: HT_SHELLS, cabinetColors: HT_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-freeport', name: 'Freeport', category: 'hot-tubs', series: 'Premium Series',
    seats: '6 Person', jets: 61, dimensions: null, gallons: null, warranty: '25-Year Structural',
    description: 'A well-balanced 6-seat Premium spa with 61 jets, deep contoured seating and high-style finishing.',
    features: F_PREMIUM,
    images: [IMG('2017-freeport-shell.jpg'), HT_LIFE2],
    shellColors: HT_SHELLS, cabinetColors: HT_CABINETS, standardShell: 'silverMarble',
  },

  // ===================== HOT TUBS — LIFESTYLE SERIES (10yr) =====================
  {
    id: 'pdc-mirage', name: 'Mirage', category: 'hot-tubs', series: 'LifeStyle Series',
    seats: '3 Person', jets: 29, dimensions: null, gallons: null, warranty: '10-Year Structural',
    description: 'A cozy body-hugging 3-seat spa — big on features, small on price, with 29 stainless Reflections™ jets.',
    features: F_LIFESTYLE,
    images: [IMG('mirage-shell.jpg'), HT_LIFE],
    shellColors: HT_SHELLS, cabinetColors: HT_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-seasons', name: 'Seasons', category: 'hot-tubs', series: 'LifeStyle Series',
    seats: '5 Person', jets: 43, dimensions: null, gallons: null, warranty: '10-Year Structural',
    description: 'Five-seat LifeStyle comfort with 43 jets, Pristine™ filtration and TemperLok™ insulation for year-round use.',
    features: F_LIFESTYLE,
    images: [IMG('seasons-shell.jpg'), HT_LIFE],
    shellColors: HT_SHELLS, cabinetColors: HT_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-summit-ht', name: 'Summit', category: 'hot-tubs', series: 'LifeStyle Series',
    seats: '7 Person', jets: 42, dimensions: null, gallons: null, warranty: '10-Year Structural',
    description: 'The largest LifeStyle model — seats 7 with 42 shiny stainless Reflections™ jets positioned for full-body relaxation.',
    features: F_LIFESTYLE,
    images: [IMG('summit-shell.jpg'), HT_LIFE],
    shellColors: HT_SHELLS, cabinetColors: HT_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-twilight', name: 'Twilight', category: 'hot-tubs', series: 'LifeStyle Series',
    seats: '5 Person', jets: 27, dimensions: null, gallons: null, warranty: '10-Year Structural',
    description: 'A relaxing 5-seat LifeStyle spa with 27 jets and craftsman reliability — an easy entry into premium hydrotherapy.',
    features: F_LIFESTYLE,
    images: [IMG('twilight-shell.jpg'), HT_LIFE],
    shellColors: HT_SHELLS, cabinetColors: HT_CABINETS, standardShell: 'silverMarble',
  },

  // ===================== SWIM SPAS — TRUSWIM (35yr) =====================
  {
    id: 'pdc-tsx15', name: 'TruSwim TSX15', category: 'swim-spas', series: 'TruSwim® Propulsion',
    seats: '15 ft', jets: 8, dimensions: '180" x 92" x 56"', gallons: '2,240', warranty: '35-Year Structural',
    description: 'Patented dual-prop propulsion delivers the widest, smoothest, most balanced swim current in the industry — in a compact 15\' footprint with a 114" open fitness area.',
    features: F_TRUSWIM,
    images: [IMG('15-truswim-shell-2-upright-large.jpg'), SWIM_LIFE],
    shellColors: ['silverMarble'], cabinetColors: SWIM_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-tsx17', name: 'TruSwim TSX17', category: 'swim-spas', series: 'TruSwim® Propulsion',
    seats: '17 ft', jets: 18, dimensions: '204" x 92" x 56"', gallons: null, warranty: '35-Year Structural',
    description: 'A 17\' TruSwim® with a 124" open fitness area and patented dual-propulsion for a true, endless swim.',
    features: F_TRUSWIM,
    images: [IMG('17-truswim-shell-w-filter-2-upright-large.jpg'), SWIM_LIFE],
    shellColors: ['silverMarble'], cabinetColors: SWIM_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-tsx19', name: 'TruSwim TSX19', category: 'swim-spas', series: 'TruSwim® Propulsion',
    seats: '19 ft', jets: 18, dimensions: '227" x 92" x 56"', gallons: null, warranty: '35-Year Structural',
    description: 'The full-size 19\' TruSwim® with a 148" open fitness area — maximum swim distance and the most even current available.',
    features: F_TRUSWIM,
    images: [IMG('19-truswim-shell-w-filter-2-upright-large.jpg'), SWIM_LIFE],
    shellColors: ['silverMarble'], cabinetColors: SWIM_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-tsx219', name: 'TruSwim TSX219', category: 'swim-spas', series: 'TruSwim® Propulsion',
    seats: 'Swim Spa + Hot Tub', jets: 37, dimensions: '227" x 92" x 56"', gallons: null, warranty: '35-Year Structural',
    description: 'Dual-zone design combines a patented TruSwim® fitness lane with a separate hot tub — swim and soak in one unit.',
    features: F_TRUSWIM,
    images: [IMG('219-truswim-dual-zone-2-rotate-upright-large.jpg'), SWIM_LIFE],
    shellColors: ['silverMarble'], cabinetColors: SWIM_CABINETS, standardShell: 'silverMarble',
  },

  // ===================== SWIM SPAS — SUMMIT (jetted) =====================
  {
    id: 'pdc-sx15', name: 'Summit SX15', category: 'swim-spas', series: 'Summit™ Jetted',
    seats: '15 ft', jets: 36, dimensions: '180" x 92" x 56"', gallons: null, warranty: '35-Year Structural',
    description: 'A 15\' jetted swim spa powered by 3 adjustable Elite Pro™ jets and 36 jets total — swim, jog or walk against a customizable current.',
    features: F_SUMMIT,
    images: [IMG('2020-sx15-shell-model-page.jpg'), SWIM_LIFE2],
    shellColors: ['silverMarble'], cabinetColors: SWIM_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-sx15s', name: 'Summit SX15s', category: 'swim-spas', series: 'Summit™ Jetted',
    seats: '15 ft (side step)', jets: 36, dimensions: '180" x 92" x 56"', gallons: null, warranty: '35-Year Structural',
    description: 'The 15\' Summit with a convenient side-step entry and 3 adjustable Elite Pro™ jets for fitness and family fun.',
    features: F_SUMMIT,
    images: [IMG('sx15s-shell-mats.png'), SWIM_LIFE2],
    shellColors: ['silverMarble'], cabinetColors: SWIM_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-sx17', name: 'Summit SX17', category: 'swim-spas', series: 'Summit™ Jetted',
    seats: '17 ft · 2 seats', jets: 36, dimensions: '204" x 92" x 56"', gallons: null, warranty: '35-Year Structural',
    description: 'A 17\' jetted swim spa with two hydrotherapy seats and powerful Elite Pro™ current programs for every skill level.',
    features: F_SUMMIT,
    images: [IMG('2020-sx17-shell-model-page.jpg'), SWIM_LIFE2],
    shellColors: ['silverMarble'], cabinetColors: SWIM_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-sx19', name: 'Summit SX19', category: 'swim-spas', series: 'Summit™ Jetted',
    seats: '19 ft', jets: 36, dimensions: '227" x 92" x 56"', gallons: null, warranty: '35-Year Structural',
    description: 'The 19\' Summit delivers a 160" fitness area and 3 adjustable Elite Pro™ jets for the ultimate at-home jetted workout.',
    features: F_SUMMIT,
    images: [IMG('2020-sx19-shell-model-page.jpg'), SWIM_LIFE2],
    shellColors: ['silverMarble'], cabinetColors: SWIM_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-sx219', name: 'Summit SX219', category: 'swim-spas', series: 'Summit™ Jetted',
    seats: 'Swim Spa + Hot Tub', jets: 64, dimensions: '227" x 92" x 56"', gallons: null, warranty: '35-Year Structural',
    description: 'Dual-zone Summit combining a 14\' jetted swim spa with a dedicated hot tub — fitness and relaxation, side by side.',
    features: F_SUMMIT,
    images: [IMG('2020-sx219-shell-model-page.jpg'), SWIM_LIFE2],
    shellColors: ['silverMarble'], cabinetColors: SWIM_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-sx219s', name: 'Summit SX219s', category: 'swim-spas', series: 'Summit™ Jetted',
    seats: 'Swim Spa + Hot Tub (side step)', jets: 64, dimensions: '227" x 92" x 56"', gallons: null, warranty: '35-Year Structural',
    description: 'The dual-zone Summit with side-step entry — a jetted swim lane plus a hot tub, with easy access.',
    features: F_SUMMIT,
    images: [IMG('2020-sx219s-shell-model-page.jpg'), SWIM_LIFE2],
    shellColors: ['silverMarble'], cabinetColors: SWIM_CABINETS, standardShell: 'silverMarble',
  },

  // ===================== SWIM SPAS — SYNERGY (jetted) =====================
  {
    id: 'pdc-fx15', name: 'Synergy FX15', category: 'swim-spas', series: 'Synergy™ Jetted',
    seats: '15 ft', jets: 36, dimensions: '180" x 92" x 56"', gallons: null, warranty: '35-Year Structural',
    description: 'A 15\' Synergy swim spa with 2 high-powered Elite Pro™ jets — walk, jog, run, swim or relax in warm swirling water.',
    features: F_SYNERGY,
    images: [IMG('fx15-shell-mats.png'), SWIM_LIFE],
    shellColors: ['silverMarble'], cabinetColors: SWIM_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-fx15s', name: 'Synergy FX15s', category: 'swim-spas', series: 'Synergy™ Jetted',
    seats: '15 ft (side step)', jets: 36, dimensions: '180" x 92" x 56"', gallons: null, warranty: '35-Year Structural',
    description: 'The 15\' Synergy with side-step entry and dual Elite Pro™ jets for family fitness and fun.',
    features: F_SYNERGY,
    images: [IMG('fx15s-shell-mats.png'), SWIM_LIFE],
    shellColors: ['silverMarble'], cabinetColors: SWIM_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-fx17', name: 'Synergy FX17', category: 'swim-spas', series: 'Synergy™ Jetted',
    seats: '17 ft · 2 seats', jets: 36, dimensions: '204" x 92" x 56"', gallons: null, warranty: '35-Year Structural',
    description: 'A 17\' Synergy swim spa with two seats and two Elite Pro™ jets for a variety of family fun and fitness options.',
    features: F_SYNERGY,
    images: [IMG('fx17-shell-mats.png'), SWIM_LIFE],
    shellColors: ['silverMarble'], cabinetColors: SWIM_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-fx19', name: 'Synergy FX19', category: 'swim-spas', series: 'Synergy™ Jetted',
    seats: '19 ft', jets: 36, dimensions: '227" x 92" x 56"', gallons: null, warranty: '35-Year Structural',
    description: 'The full 19\' Synergy with a 160" fitness area and dual Elite Pro™ jets for a healthier, happier you.',
    features: F_SYNERGY,
    images: [IMG('fx19-shell-mats.png'), SWIM_LIFE],
    shellColors: ['silverMarble'], cabinetColors: SWIM_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-fx219', name: 'Synergy FX219', category: 'swim-spas', series: 'Synergy™ Jetted',
    seats: 'Swim Spa + Hot Tub', jets: 65, dimensions: '227" x 92" x 56"', gallons: null, warranty: '35-Year Structural',
    description: 'Dual-zone Synergy pairs a 14\' jetted swim spa with a separate hot tub — the best of both worlds.',
    features: F_SYNERGY,
    images: [IMG('fx219-shell-mats.png'), SWIM_LIFE],
    shellColors: ['silverMarble'], cabinetColors: SWIM_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-fx219s', name: 'Synergy FX219s', category: 'swim-spas', series: 'Synergy™ Jetted',
    seats: 'Swim Spa + Hot Tub (side step)', jets: 65, dimensions: '227" x 92" x 56"', gallons: null, warranty: '35-Year Structural',
    description: 'The dual-zone Synergy with side-step entry — a jetted swim lane and a hot tub, with easy access.',
    features: F_SYNERGY,
    images: [IMG('fx219s-shell-mats.png'), SWIM_LIFE],
    shellColors: ['silverMarble'], cabinetColors: SWIM_CABINETS, standardShell: 'silverMarble',
  },

  // ===================== SWIM SPAS — SPLASH SERIES (35yr) =====================
  {
    id: 'pdc-splash12', name: 'Splash12', category: 'swim-spas', series: 'Splash Series',
    seats: 'Seats 8', jets: 59, dimensions: '144" x 92" x 50"', gallons: null, warranty: '35-Year Structural',
    description: 'A 12\' pool-alternative that balances a hot tub and fitness spa. Seating for 8, 59 therapy jets, plus an Elite Pro™ fitness jet for aquatic exercise.',
    features: F_SPLASH,
    images: [IMG('source/2024-splashpak-baja12-shell.png'), SWIM_LIFE2],
    shellColors: ['silverMarble'], cabinetColors: SWIM_CABINETS, standardShell: 'silverMarble',
  },
  {
    id: 'pdc-splash15', name: 'Splash15', category: 'swim-spas', series: 'Splash Series',
    seats: 'Seats 10', jets: 67, dimensions: '180" x 92" x 50"', gallons: null, warranty: '35-Year Structural',
    description: 'A 15\' pool-alternative built for larger gatherings — seating for 10, 67 therapy jets and an adjustable Elite Pro™ fitness jet.',
    features: F_SPLASH,
    images: [IMG('baja-15-portable.png'), SWIM_LIFE2],
    shellColors: ['silverMarble'], cabinetColors: SWIM_CABINETS, standardShell: 'silverMarble',
  },

  // ===================== COLD PLUNGES — X-DEGREE =====================
  {
    id: 'pdc-xd1', name: 'X-Degree XD1', category: 'cold-plunges', series: 'X-Degree Series',
    seats: 'Seats 1', jets: 0, dimensions: '93" x 39" x 32"', gallons: '100', warranty: 'Standard Limited',
    description: 'Pure cold therapy. Simple, powerful and effective — a compact, minimalist plunge for focused recovery and daily wellness. 100 gal · 110V/15A.',
    features: F_COLD,
    images: [IMG('XD1_Shell.webp'), COLD_LIFE],
    shellColors: ['silverMarble'], cabinetColors: ['black'], standardShell: 'silverMarble',
  },
  {
    id: 'pdc-xd1plus', name: 'X-Degree XD1+', category: 'cold-plunges', series: 'X-Degree Series',
    seats: 'Seats 1', jets: 7, dimensions: '93" x 39" x 32"', gallons: '100', warranty: 'Standard Limited',
    description: 'Cold therapy with hydrotherapy relief. The XD1+ adds 7 hydrotherapy jets for targeted muscle relief and improved circulation. 100 gal · 110V/15A.',
    features: ['7 Hydrotherapy Jets', ...F_COLD],
    images: [IMG('XD1_Shell_27f6167e-9160-4c85-8c6c-994797658123.png'), COLD_LIFE],
    shellColors: ['silverMarble'], cabinetColors: ['black'], standardShell: 'silverMarble',
  },
  {
    id: 'pdc-xd2', name: 'X-Degree XD2', category: 'cold-plunges', series: 'X-Degree Series',
    seats: 'Hot: 4 · Cold: 1', jets: 28, dimensions: '90" x 79" x 32"', gallons: 'Hot 180 / Cold 63', warranty: 'Standard Limited',
    description: 'Dual-zone innovation — independent hot and cold zones for true combination therapy in one unit. 28 hydrotherapy + 27 air jets. 240V/50A, 6HP peak.',
    features: ['Independent Hot & Cold Zones', '28 Hydrotherapy Jets + 27 Air Jets', '6HP Peak / 3HP Continuous + 1.5HP Blower', ...F_COLD],
    images: [IMG('91224_XD2_Shell.webp'), COLD_LIFE2],
    shellColors: ['silverMarble'], cabinetColors: ['black'], standardShell: 'silverMarble',
  },
];

// Hero / banner imagery for the page
export const PDC_SPAS_HERO = IMG('hot-tub-relax.webp');
export const PDC_SPAS_LIFESTYLE = IMG('hp-block-2.webp');
